module.exports = __webpack_public_path__ + "static/media/111.bc934f29.png";